export const LoadingRing = ({ className }: { className?: string }) => {
  return (
    <div
      style={{
        animation:
          "loader-squish 1s infinite cubic-bezier(0.7, -1, 0.26, 1.75)",
      }}
      className={`w-[60px] h-[60px] flex items-center justify-center origin-center relative ${
        className || ""
      }`}
    >
      <div
        style={{
          animation: "spin 1s infinite cubic-bezier(0.7, -1, 0.26, 1.75)",
        }}
        className={` absolute top-0 rounded-full h-[40px] w-[40px] border-8 border-white/40 border-b-white
        `}
      ></div>
    </div>
  )
}
